import type { ShouldRevalidateFunction } from 'react-router'

/** Only reuse data already loaded for this exact page and Session. */
export const shouldRevalidate: ShouldRevalidateFunction = (args) => {
  const { currentUrl, nextUrl, defaultShouldRevalidate, formMethod } = args
  // Saves, explicit refresh, path/Session changes and unknown filters retain
  // React Router's normal revalidation and all server authorization checks.
  if ((formMethod && formMethod.toUpperCase() !== 'GET') ||
      currentUrl.origin !== nextUrl.origin || currentUrl.pathname !== nextUrl.pathname ||
      currentUrl.search === nextUrl.search) return defaultShouldRevalidate

  const keys = /^\/crews\/[^/]+$/.test(currentUrl.pathname)
    ? ['tab']
    : /^\/live(?:\/(?:ops|moderate|field))?$/.test(currentUrl.pathname)
      ? ['crew', 'day', 'panel', 'section', 'following']
      : []
  if (!keys.length) return defaultShouldRevalidate
  const current = new URLSearchParams(currentUrl.search)
  const next = new URLSearchParams(nextUrl.search)
  for (const key of keys) {
    current.delete(key)
    next.delete(key)
  }
  current.sort()
  next.sort()
  return current.toString() === next.toString() ? false : defaultShouldRevalidate
}
